/**
 *  このファイルはtools/generate.tsにより生成されたファイルです。手動で編集しないでください。
 */

import { EntityDataApi } from "../../IndexedDBApi";
import { WorkBase } from "../../../../schema/generated/Work";
import { idbEntityDefs } from "../../generated/entityDefs";

// 固有処理を持たない薄いDataApi。共通CRUD/キャッシュはEntityDataApiに集約。
export class WorkDataApi extends EntityDataApi<WorkBase> {
  public readonly def = idbEntityDefs.Work;
}